export default __webpack_public_path__ + "static/aayushi3-19c5d524f951552398b866af3eb73a23.jpg";